import { Link } from 'react-router-dom';

const footerLinks = {
  spreadsheets: [
    { label: 'Shoes Spreadsheet', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { label: 'Hoodies Spreadsheet', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { label: 'T-Shirts Spreadsheet', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { label: 'Jackets Spreadsheet', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
    { label: 'Accessories Spreadsheet', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  ],
  resources: [
    { label: 'Pandabuy Sheet Guide', url: '/blog/pandabuy-sheet-guide-2026' },
    { label: 'Category Hub', url: '#categories' },
    { label: 'Trending Deals', url: '#trending' },
    { label: 'Blog Articles', url: '#blog' },
    { label: 'Main Platform', url: 'https://kaspreadsheet.com' },
  ],
  legal: [
    { label: 'Privacy Policy', url: 'https://kaspreadsheet.com' },
    { label: 'Terms of Service', url: 'https://kaspreadsheet.com' },
    { label: 'Disclaimer', url: 'https://kaspreadsheet.com' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 pt-16 pb-8 px-6 md:px-10 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-50 rounded-3xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-1">
              <Link to="/" className="text-lg font-bold tracking-tight text-foreground-950">
                Pandabuy<span className="font-light">Spreadsheet</span>
              </Link>
              <p className="text-foreground-500 text-sm mt-4 leading-relaxed">
                Your trusted source for curated product sourcing spreadsheets,
                price comparisons, and smart shopping intelligence. Updated daily.
              </p>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                Spreadsheets
              </h4>
              <ul className="space-y-3">
                {footerLinks.spreadsheets.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                Resources
              </h4>
              <ul className="space-y-3">
                {footerLinks.resources.map((link) =>
                  link.url.startsWith('/') ? (
                    <li key={link.label}>
                      <Link
                        to={link.url}
                        className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ) : link.url.startsWith('#') ? (
                    <li key={link.label}>
                      <a
                        href={link.url}
                        className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  )
                )}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                Legal
              </h4>
              <ul className="space-y-3">
                {footerLinks.legal.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 Pandabuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 rounded-full bg-foreground-950 text-white flex items-center justify-center text-xs hover:bg-foreground-800 transition-all cursor-pointer"
            >
              <i className="ri-twitter-x-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 rounded-full bg-foreground-950 text-white flex items-center justify-center text-xs hover:bg-foreground-800 transition-all cursor-pointer"
            >
              <i className="ri-instagram-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}